// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/AccountDerivationRule.yaml
// Generated: 2026-06-15T15:19:19.806Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateAccountDerivationRule, UpdateAccountDerivationRule, AccountDerivationRule } from '@/types/finance/AccountDerivationRule';

/**
 * AccountDerivationRule Service
 * CRUD operations for AccountDerivationRule via the ABP API.
 */
export const accountDerivationRuleService = new EntityService<AccountDerivationRule, CreateAccountDerivationRule, UpdateAccountDerivationRule>(
  '/api/finance/accountderivationrule',
  'AccountDerivationRule',
);
